import React from 'react';
import styled, { css } from 'styled-components';
import { formatCurrency } from 'js/services/Format';
import { greenColor } from 'js/config/style';

const userOwesMoney = css`
  color: red;
  font-weight: 500;
`;

const noBalance = css`
  color: black;
`;

const payoutWaiting = css`
  color: ${greenColor};
  font-weight: 500;
`;

const Container = styled.div`
  ${({ balance }) => (balance > 0 ? userOwesMoney : !balance ? noBalance : payoutWaiting)}
`;

export default ({ balance }) => <Container balance={balance}>{formatCurrency(Math.abs(balance))}</Container>;
